var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReplayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.407,13.661a1.192,1.192,0,0,1,1.675.189l1.889,2.364a13.042,13.042,0,1,1,2.15,9.123,1.178,1.178,0,0,1,.309-1.643A1.192,1.192,0,0,1,12.081,24a10.623,10.623,0,1,0-1.806-7.09l2.887-1.985a1.192,1.192,0,0,1,1.574.362,1.178,1.178,0,0,1-.243,1.588L9.539,20.22a1.192,1.192,0,0,1-1.6-.248L4.264,15.327a1.177,1.177,0,0,1,.143-1.666Z",
    transform: "translate(-3.984 -5.008)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplayVideo);
export default __webpack_public_path__ + "static/media/icon-replay-video.35ba9f78c6e8e8fb26854f1a3dc06b31.svg";
export { ForwardRef as ReactComponent };